import mock from '@/api/mocks/mockAdapter';

import './auth/auth.mock';

mock.onAny().passThrough();
